module.exports = __webpack_public_path__ + "img/default-image.39bb6bc9.svg";